module.exports = {
      id: "arrow-2-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#arrow-2-usage",
      toString: function () {
        return this.url;
      }
    }